
import React from "react";

const ProgressBar = ({ currentStep, steps }) => {
  const progressPercentage = (currentStep / (steps?.length - 1)) * 100;

  return (
    <div className="progress-bar questionnaire-progress bg-transparent">
      <div
        className="progress-bar-fill"
        style={{ width: `${progressPercentage}%` }}
      ></div>
      <div className="steps d-flex justify-content-center align-items-start">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`step ${index <= currentStep ? "active" : ""}`}
          ></div>
        ))}
      </div>
    </div>
  );
};
export default ProgressBar;